import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Layout, Menu, Button, theme } from 'antd';
import { MdDashboardCustomize, MdInvertColors, MdNotificationsActive } from 'react-icons/md'
import { Link, useNavigate } from 'react-router-dom';
import { AiOutlineShoppingCart, AiOutlineUser, AiOutlineMenu, AiOutlineSetting } from 'react-icons/ai';
import { SiBrandfolder } from 'react-icons/si';
import { BiCategoryAlt, BiSolidCoupon, BiLogOutCircle } from 'react-icons/bi';
import { FaClipboardList, FaBlog, FaMicroblog } from 'react-icons/fa';
import { ImBlog } from 'react-icons/im';
import { TbWorldQuestion } from 'react-icons/tb';
import { Outlet } from 'react-router-dom';
import { useSelector} from 'react-redux';
import { FaUserTie } from "react-icons/fa6";

const { Header, Sider, Content } = Layout;
const Mainlayout = () => {
  const authState = useSelector(state=>state?.auth)
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const navigate = useNavigate();
  return (
    <Layout /*onContextMenu={(e) => e.preventDefault()}*/>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="logo demo-logo-vertical text-center fs-6 py-0 mb-0" >
          <a rel="Nile" href="https://a-nile.com/" className="nav-a">
            <svg data-v-fde0c5aa="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" className="iconAbove" aria-hidden="true" focusable="false" width="6em" height="4em"><defs data-v-fde0c5aa=""></defs><rect data-v-fde0c5aa="" fill="transparent" x="0" y="0" width="300px" height="300px" className="logo-background-square"></rect><defs data-v-fde0c5aa=""></defs>
              <g data-v-fde0c5aa="" id="86a1221b-7f9c-4b4b-ae81-248d0df7c96e" fill="#000000" transform="matrix(2.7057812213897705,0,0,2.7057812213897705,127.60966160198568,165.95385794818253)"><path d="M4.45 14.71L3.39 14.71L2.58 6.30L2.58 6.30Q2.49 6.94 2.40 7.63L2.40 7.63L2.40 7.63Q2.31 8.32 2.18 9.26L2.18 9.26L2.18 9.26Q2.04 10.21 1.86 11.52L1.86 11.52L1.86 11.52Q1.68 12.82 1.41 14.71L1.41 14.71L0.49 14.71L2.10 3.19L3.37 3.19L3.95 11.63L3.95 11.63Q4.00 11.24 4.06 10.84L4.06 10.84L4.06 10.84Q4.12 10.43 4.19 9.93L4.19 9.93L4.19 9.93Q4.26 9.44 4.35 8.82L4.35 8.82L4.35 8.82Q4.44 8.20 4.55 7.40L4.55 7.40L4.55 7.40Q4.66 6.59 4.80 5.56L4.80 5.56L4.80 5.56Q4.94 4.52 5.12 3.19L5.12 3.19L6.06 3.19L4.45 14.71ZM6.55 14.71L5.49 14.71L7.10 3.19L8.16 3.19L6.55 14.71ZM10.74 14.71L7.62 14.71L9.23 3.19L10.29 3.19L8.82 13.66L10.88 13.66L10.74 14.71ZM14.52 14.71L11.40 14.71L13.01 3.19L16.06 3.19L15.90 4.27L13.92 4.27L13.36 8.32L14.76 8.32L14.60 9.38L13.20 9.38L12.60 13.66L14.66 13.66L14.52 14.71Z"></path></g><defs data-v-fde0c5aa=""><linearGradient data-v-fde0c5aa="" gradientTransform="rotate(25)" id="e8619ee0-36ee-4abc-bad4-1e77a0708af1" x1="0%" y1="0%" x2="100%" y2="0%"><stop data-v-fde0c5aa="" offset="0%" stop-color="#041804" stop-opacity="1"></stop><stop data-v-fde0c5aa="" offset="100%" stop-opacity="1"></stop></linearGradient></defs><g data-v-fde0c5aa="" id="1164f2e8-15ad-443e-ac63-cd201a601be2" stroke="none" fill="url(#e8619ee0-36ee-4abc-bad4-1e77a0708af1)" transform="matrix(2.778252601623535,0,0,2.778252601623535,9.234270773395796,-27.651737019373982)"><path d="M52.5 55.563c7 0 11.063-7.688 11.063-7.688s-3.03 4.188-10.5 4.188c-5.438 0-9.75-8.188-20.125-8.188-8.485 0-14.375 8.583-20.826 8.583C8.861 52.458 3.875 48 3.875 48s2.813 7.563 9 7.563c9.625 0 13.313-5.844 20.25-5.844 8.188 0 9.813 5.844 19.375 5.844zm24.667-9.48c-7.323 0-10 7.917-10 7.917s4.322-3.042 9.625-2.167c4.542.75 9.042 6.083 20.667 5.333-4.85-2.15-13.271-11.083-20.292-11.083zm-.542 9.48c-8.688 0-15.537 5.165-22.688 5.063s-9.625-4.5-17.75-4.5c-5.188 0-6.688 5.188-6.688 5.188s1.929-2.25 5.625-2.25c5.188 0 11.058 7.25 19 7.25 12.438 0 17.375-7 22.875-7 4.75 0 10.688 3.75 10.688 3.75s-4.062-7.501-11.062-7.501z"></path></g>
            </svg>
          </a>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={['']}
          onClick={({ key }) => {
            if (key === 'signout') {
              localStorage.clear()
              window.location.reload()
            } else {
              navigate(key);
            }
          }}
          items={[
            {
              key: '',
              icon: <MdDashboardCustomize className='fs-4' />,
              label: 'Dashboard',
            },
            {
              key: 'customer',
              icon: <AiOutlineUser className='fs-4' />,
              label: 'Customers',
            },
            {
              key: 'catalog',
              icon: <BiCategoryAlt className='fs-4' />,
              label: 'Catalog',
              children: [
                {
                  key: 'product',
                  icon: <AiOutlineShoppingCart className='fs-4' />,
                  label: 'Add Product',
                },
                {
                  key: 'product-list',
                  icon: <AiOutlineShoppingCart className='fs-4' />,
                  label: 'Product List',
                },
                {
                  key: 'brand',
                  icon: <SiBrandfolder className='fs-4' />,
                  label: 'Add Brand',
                },
                {
                  key: 'list-brand',
                  icon: <SiBrandfolder className='fs-4' />,
                  label: 'Brand List',
                },
                {
                  key: 'category',
                  icon: <BiCategoryAlt className='fs-4' />,
                  label: 'Add Category',
                },
                {
                  key: 'list-category',
                  icon: <BiCategoryAlt className='fs-4' />,
                  label: 'Category List',
                },
                {
                  key: 'color',
                  icon: <MdInvertColors className='fs-4' />,
                  label: 'Add Color',
                },
                {
                  key: 'color-list',
                  icon: <MdInvertColors className='fs-4' />,
                  label: 'Color List',
                },
              ]
            },
            {
              key: 'order',
              icon: <FaClipboardList className='fs-4' />,
              label: 'Orders',
            },
            {
              key: 'marketing',
              icon: <BiSolidCoupon className='fs-4' />,
              label: 'Marketing',
              children: [
                {
                  key: 'coupon',
                  icon: <BiSolidCoupon className='fs-4' />,
                  label: 'Add Coupon',
                },
                {
                  key: 'coupon-list',
                  icon: <BiSolidCoupon className='fs-4' />,
                  label: 'Coupon List',
                },
              ]
            },
            {
              key: 'blogs',
              icon: <FaBlog className='fs-4' />,
              label: 'Blogs',
              children: [
                {
                  key: 'blog',
                  icon: <ImBlog className='fs-4' />,
                  label: 'Add Blog',
                },
                {
                  key: 'blog-list',
                  icon: <FaMicroblog className='fs-4' />,
                  label: 'Blog List',
                },
                {
                  key: 'blog-category',
                  icon: <ImBlog className='fs-4' />,
                  label: 'Add Blog Category',
                },
                {
                  key: 'blog-category-list',
                  icon: <FaMicroblog className='fs-4' />,
                  label: 'Blog Category List',
                },
              ]
            },
            {
              key: 'enquiries',
              icon: <TbWorldQuestion  className='fs-4' />,
              label: 'Enquiries',
            },
            {
              key: 'profile',
              icon: <AiOutlineSetting className='fs-4' />,
              label: 'Settings',
            },
            {
              key: 'signout',
              icon: <BiLogOutCircle className='fs-4' />,
              label: 'Sign out',
            },
          ]}
        />
      </Sider>
      <Layout className='site-layout'>
        <Header className='d-flex justify-content-between ps-0 pe-4'
          style={{
            padding: 0,
            background: colorBgContainer,
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <AiOutlineMenu /> : <AiOutlineMenu />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: '16px',
              width: 64,
              height: 64,
            }}
          />
          <div className='d-flex gap-3 align-items-center'>
            <div className='position-relative'>
              <MdNotificationsActive className='fs-4' />
              <span className='badge bg-warning rounded-circle p-1 position-absolute'>0</span>
            </div>
            <div className='d-flex gap-3 align-items-center dropdown' >
              <div> 
                <FaUserTie className='fs-4'/>
              </div>
              <div role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                <Link to={ authState?.user===null? '/':''} className='d-flex align-items-center gap-10 text-dark'>
                  {
                    authState?.user===null ? <p className='mb-0'>Sign in</p> : <p className='mb-0'>Hello {authState?.user?.firstname}</p>
                  }
                </Link>
              </div>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <li><Link className="dropdown-item py-1 mb-1" style={{height: 'auto', lineHeight: '20px'}} to="/contact">Contact</Link></li>
              </div>
            </div>
          </div>
        </Header>
        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
          }}
        >
          <ToastContainer position="top-right" autoClose={250} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable theme="light" />
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
export default Mainlayout;